import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Index',
		component: Index,
		meta: {
			title: "商城首页",
			keepAlive: true
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('../views/Login.vue'),
		meta: {
			title: "登录",
			keepAlive: false
		}
	},
	{
		path: '/reg',
		name: 'Reg',
		component: () => import('../views/Reg.vue'),
		meta: {
			title: "注册",
			keepAlive: false
		}
	},
	{
		path: '/goodslist',
		name: 'Goodslist',
		component: () => import('../views/Goodslist.vue'),
		meta: {
			title: "商品搜索",
			keepAlive: true
		}
	},
	{
		path: '/goodsinfo',
		name: 'Goodsinfo',
		component: () => import('../views/Goodsinfo.vue'),
		meta: {
			title: "商品详情",
			keepAlive: true
		}
	},
	{
		path: '/about',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
	},
	{
		path: '/member',
		name: 'MemberIndex',
		component: () => import('../views/Member/Index.vue'),
		meta: {
			title: "我的",
			needlogin: true,
			keepAlive: true
		}
	},
	{
		path: '/member/cart',
		name: 'Cart',
		component: () => import('../views/Member/Cart.vue'),
		meta: {
			title: "购物车",
			needlogin: true,
			keepAlive: true
		}
	},
	{
		path: '/member/orderdetail',
		name: 'Orderdetail',
		component: () => import('../views/Member/Orderdetail.vue'),
		meta: {
			title: "订单明细",
			needlogin: true,
			keepAlive: true
		}
	},
	{
		path: '/member/commentedit',
		name: 'Commentedit',
		component: () => import('../views/Member/Commentedit.vue'),
		meta: {
			title: "订单评价",
			needlogin: true,
			keepAlive: true
		}
	},
	{
		path: '/member/buy',
		name: 'Buy',
		component: () => import('../views/Member/Buy.vue'),
		meta: {
			title: "订单结算",
			needlogin: true,
			keepAlive: false
		}
	},
	{
		path: '/member/pay',
		name: 'Pay',
		component: () => import('../views/Member/Pay.vue'),
		meta: {
			title: "订单支付",
			needlogin: true,
			keepAlive: false
		}
	},
	{
		path: '/member/paysuccess',
		name: 'Paysuccess',
		component: () => import('../views/Member/Paysuccess.vue'),
		meta: {
			title: "订单支付",
			needlogin: true,
			keepAlive: false
		}
	},
	{
		path: '/member/afterserviceedit',
		name: 'Afterserviceedit',
		component: () => import('../views/Member/Afterserviceedit.vue'),
		meta: {
			title: "售后申请",
			needlogin: true,
			keepAlive: false
		}
	},
	{
		path: '/member/afterservicedetail',
		name: 'Afterservicedetail',
		component: () => import('../views/Member/Afterservicedetail.vue'),
		meta: {
			title: "售后详情",
			needlogin: true,
			keepAlive: false
		}
	},
	{
		path: '/help/',
		name: 'Help',
		component: () => import('../views/Help.vue'),
		meta: {
			title: "帮助中心",
			keepAlive: true
		}
	},
	{
		path: '/alipay',
		name: 'Alipay',
		component: () => import('../views/Alipay.vue'),
		meta: {
			title: "支付宝付款",
			needlogin: true,
			keepAlive: false
		}
	},
	{
		path: '/error',
		name: 'Error',
		component: () => import('../views/Error.vue'),
		meta: {
			title: "错误页面",
			keepAlive: true
		}
	},
	{
		path: '/integralmall',
		name: 'IntegralMall',
		component: () => import('../views/IntegralMall.vue'),
		meta: {
			title: "积分商城",
			keepAlive: true
		}
	},
	{
		path: '/diy',
		name: 'Diy',
		component: () => import('../views/Diy.vue'),
		meta: {
			title: "商城页面",
			keepAlive: true
		}
	},
	{
		path: '/miaosha',
		name: 'Miaosha',
		component: () => import('../views/Zt/Seckill.vue'),
		meta: {
			title: "每日秒杀",
			keepAlive: true
		}
	},
	{
		path: '/pintuan',
		name: 'Pintuan',
		component: () => import('../views/Zt/Pintuan.vue'),
		meta: {
			title: "拼团专区",
			keepAlive: true
		}
	},
	{
		path: '/yushou',
		name: 'Yushou',
		component: () => import('../views/Zt/Yushou.vue'),
		meta: {
			title: "预售专区",
			keepAlive: true
		}
	},
	{
		path: '/mima',
		name: 'Resetpassword',
		component: () => import('../views/Member/Resetpassword.vue'),
		meta: {
			title: "忘记密码"
		}
	},
	{ path: '*', redirect: '/error', hidden: true }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
